import {volanteer_reducer} from './volanteer'
import { reducer as App_Settings_reducer} from './App_Settings/reducer'
import { userMetadataReducer } from './App_Settings/userMetadataReducer'
import { DbBrowserReducer } from './components/Body/DbBrowser'
import { chatReducer } from './Redux/chatReducer'
import {configureStore} from '@reduxjs/toolkit'
// import {createStore} from 'redux'
const store = configureStore(
    {
        reducer:{
            App_Settings:App_Settings_reducer,
            UserMetaData:userMetadataReducer,
            volanteer:volanteer_reducer,
            DbBrowser:DbBrowserReducer,
            Chat:chatReducer,
            // Body:()=>{},

        }
    }
)
window.store=store
export default store;